import { createIconComponent } from '../../factory/create-icon-component';
export const ClipboardTextIcon = createIconComponent(
  'ClipboardTextIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4283 3C17.9531 3 19.9998 5.0467 19.9998 7.57143V14.0001C19.9998 16.8003 19.9998 18.2004 19.4548 19.2699C18.9754 20.2108 18.2105 20.9757 17.2697 21.4551C16.2001 22 14.8 22 11.9998 22H11.656C9.17957 22 7.94135 22 6.97368 21.5711C5.83886 21.0681 4.93172 20.1609 4.42872 19.0261C3.99981 18.0584 3.99983 16.8202 3.99986 14.3438L3.99976 14V10V7.57143C3.99976 5.0467 6.04645 3 8.57118 3M8.99976 11H14.9998M8.99976 15H12.9998M13.9999 5H9.99988C8.89531 5 7.99988 4.10457 7.99988 3C7.99988 1.89543 8.89531 1 9.99988 1H11.9999H13.9999C14.502 1.09525 14.7977 1.14749 14.9999 1.26756C15.3035 1.4432 15.5567 1.69637 15.7323 2C15.9025 2.29417 15.9999 2.63571 15.9999 3C15.9999 4.10457 15.1044 5 13.9999 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
